import IProduct from "@/interfaces/product.interface";

type UseProductDataReturn = Partial<IProduct> & {
  isActive: boolean;
  productType: string;
  brand: string;
  variationLabel: string;
  totalStock: number;
};

type UseProductDataMessages = {
  kitOption: string;
  simpleProductOption: string;
  variationProductOption: string;
};

type UseProductDataProps = { product: IProduct | null; messages: UseProductDataMessages };

function useProductData({ product, messages }: UseProductDataProps): UseProductDataReturn {
  const { kitOption, simpleProductOption, variationProductOption } = messages;

  const isActive = product?.active ?? false;
  const brand = product?.brand ?? "-";

  const skus = product?.skus ?? [];

  let productType = simpleProductOption;
  if (skus.some((sku) => sku.kit)) {
    productType = kitOption;
  } else if (product?.variationCode) {
    productType = variationProductOption;
  }

  let variations: { VariationName?: string; name?: string }[] = [];
  const raw = product?.variations;
  if (Array.isArray(raw)) {
    variations = raw as { VariationName?: string; name?: string }[];
  } else if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw) as { VariationName?: string; name?: string }[];
      variations = Array.isArray(parsed) ? parsed : [];
    } catch {
      variations = [];
    }
  }
  const variationNames = variations
    .map((v) => v.VariationName ?? v.name ?? "")
    .filter((s) => s.length > 0);
  const variationLabel =
    variationNames.length > 0 ? variationNames.join(", ") : "-";

  const totalStock = skus.reduce(
    (acc, sku) => acc + (typeof sku.stock === "number" ? sku.stock : Number(sku.stock) || 0),
    0
  );

  return { ...product, isActive, productType, brand, variationLabel, totalStock };
}

export default useProductData;
